module.exports = __webpack_public_path__ + "static/media/floral-bell-variant-outline-with-flower-buds-and-vines-svgrepo-com.9c0194cd.svg";